<div class="container-fluid">
    <div class="row no-gutter">
        <div class="col-md-3 d-none d-md-flex bg-image">
            <div class="container"></div>
        </div>
        <div class="col-md-6">
            <div class="login d-flex align-items-center py-5">
                <div class="container">
                    <img src="assets/top2.png" class="img resptilt" />
                    <div class="row">
                        <img src="../../../assets/logo.png" style="width:275px;margin: auto;" />
                    </div>
                    <div class="row">
                        <div class="col-lg-7 col-xl-6 mx-auto">
                            <div class="text-danger text-center mb-3" style="border:1px solid #efefef" *ngIf="errorMessage">
                                <h5 style="margin-top: 5px;">{{ this.errorMessage }}</h5>
                            </div>
                            <br/>
                            <form [formGroup]="loginForm" (ngSubmit)="onClickLogin()">
                                <div class="form-group mb-3">
                                    <input id="inputEmail" type="email" placeholder="Email address" formControlName="email" autofocus="" class="form-control rounded-pill border-0 shadow-sm px-4" />
                                </div>
                                <div class="form-group mb-3">
                                    <input id="inputPassword"  placeholder="Password" formControlName="password" class="form-control rounded-pill border-0 shadow-sm px-4 text-danger" /><br />
                                    <input type="checkbox" style="margin-right: 5px; margin-left:24px;" (click)="myFunction()">Show Password
                                </div>
                                <div class="custom-control custom-checkbox mb-3">
                                    <input id="customCheck1" type="checkbox" checked class="custom-control-input" />
                                    <h6 type="button" style="color: #00cec9;" data-toggle="modal" data-target="#exampleModal">forget password</h6>
                                </div>
                                <button type="submit" class="btn btn-danger btn-block text-uppercase mb-2 rounded-pill shadow-sm">
                                  Sign in as doctor
                                </button>

                                <!-- <div class="text-center" style="margin-top: 1rem">
                                    <p>
                                        <a style="cursor: pointer" routerLink="/registration">
                                            <u>Create Account</u></a>
                                    </p>
                                </div> -->
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 d-none d-md-flex bg-white">

          <!-- Modal for forget password-->
          <div class="modal fade" id="exampleModal"  tabindex="-1"  aria-labelledby="exampleModalLabel" aria-hidden="true" >
            <div class="modal-dialog" >
              <div class="modal-content" >
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Reset Password</h5>
                  <button type="button" #closeforgetPass class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <div  *ngIf="isLoading" class="loader text-center" style="margin: 0 auto;">
                  </div>
                   <div *ngIf="!isLoading">
                  <form *ngIf="emailTime" [formGroup]="emailForm" >
                    <div class="form-group">
                      <label for="exampleInputEmail1">Email address</label>
                      <input type="email" formControlName="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
                      <small id="emailHelp" class="form-text text-muted">Enter Registered Email Address To Find Your Account</small>
                    </div>
                  </form>
                  <form *ngIf="otpTime">
                    <p>OTP Successfully send to <b>{{emailForm.value.email}}</b></p>
                    <p (click)="wrongemail()" style="color: #00cec9;">Wrong Email Address</p>
                    <p>{{timeLeft}} sec</p>
                    <button class="btn btn-primary" [disabled]="!showResendFlag" (click)="submitEmail()">Resend OTP</button>
                  </form>
                  <form *ngIf="passTime" [formGroup]="passForm">
                    <div class="form-group row">
                      <label for="inputPassword" placeholder="New Password" class="col-sm-2 col-form-label">New Password</label>
                      <div class="col-sm-10">
                        <input type="password" formControlName="pass" class="form-control" >
                      </div>
                    </div>
                  </form>
                  <form *ngIf="passTime" [formGroup]="confirmPassFrom">
                    <div class="form-group row">
                      <label for="inputPassword"  class="col-sm-2 col-form-label">Confirm Password</label>
                      <div class="col-sm-10">
                        <input type="password" (input)="checker()" (change)="notVerify()" formControlName="confirmPass" class="form-control" >
                        <div *ngIf="showStatus" class="alert alert-danger">
                          <div *ngIf="showStatus">Password and Confirm Password must be match.</div>
                        </div>
                       </div>
                    </div>
                  </form>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button *ngIf="emailTime" type="button" class="btn btn-primary" (click)="submitEmail()" [disabled]="!emailForm.valid" >Submit</button>
                    <button *ngIf="otpTime" type="button" class="btn btn-primary" (click)="submitOtp()" [disabled]="this.otpForm.value.otp && this.otpForm.value.otp.length < 999" >Submit</button>
                    <button *ngIf="passTime" type="button" class="btn btn-primary" (click)="submitPass()" [disabled]="!verifyPass" >Submit</button>
                  </div>
                  </div>
                 </div>
               </div>
             </div>
          </div>
        </div>
     </div>
  </div>